import { DashboardIntervalStatFragment } from '@/graphql'

export const hasDataPointMeaningfulData = (
  dataPoint: DashboardIntervalStatFragment,
): boolean => {
  return (
    (dataPoint.insideSales !== null && dataPoint.insideSales > 0) ||
    dataPoint.emptyFacings !== null ||
    dataPoint.compliance !== null ||
    dataPoint.restockCompletion !== null ||
    dataPoint.taskCompletion !== null
  )
}

export const filterDataPointsWithMeaningfulData = (
  dataPoints: DashboardIntervalStatFragment[],
): DashboardIntervalStatFragment[] => {
  return dataPoints.filter(hasDataPointMeaningfulData)
}
